
export class UploadItem {
file: string;
fileFormat: string;
fileName: string;
}

